<template>
  <el-config-provider :locale="elementPlusLocale">
    <router-view />
  </el-config-provider>
</template>

<script>
import { onBeforeMount } from 'vue'
import { elementPlusLocale, initElementPlusLocale } from '@/composables/useAppLocale'
import { readStoredLocale } from '@/constants/locale'

export default {
  name: 'App',
  setup () {
    onBeforeMount(async () => {
      if (!elementPlusLocale.value) {
        await initElementPlusLocale(readStoredLocale())
      }
    })

    return {
      elementPlusLocale
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: #f5f5f5;
}
</style>
